<div class="footer-holder">
    <div class="footer-holder2">
        <div class="copyright">&copy; 2023 - <a href="https://akiru.se/" target="_blank">Akiru Studios AB</a></div>
    </div>
</div>
